export const MERCHANT_PERMISSION_GET ="/MerchantPermission/GetMerchantPermissionByUserName"
export const MERCHANT_SUBMERCHANTID_GET ="/MerchantPermission/GetSubMerchantIdByUserName"
export const MERCHANT_PERMISSION_BYMERCHANTID_GET ="/MerchantPermission/GetMerchantPermissionByMerchantId"